module.exports = __webpack_public_path__ + "static/evelyn-3b563603346951cc864df843e1c1c2a7.png";